import { render, staticRenderFns } from "./OssMediaThumbs.vue?vue&type=template&id=1d545fc4&scoped=true"
import script from "./OssMediaThumbs.vue?vue&type=script&lang=js"
export * from "./OssMediaThumbs.vue?vue&type=script&lang=js"
import style0 from "./OssMediaThumbs.vue?vue&type=style&index=0&id=1d545fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d545fc4",
  null
  
)

export default component.exports